import { X } from "lucide-react";
import React from "react";

const DecisionModal = ({ candidate, decisionData, onChange, onSubmit, onClose, loading }) => {
  if (!candidate) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 z-[99999] flex flex-col justify-end items-center">
      <div className="bg-white w-full max-h-[90vh] max-w-[600px] rounded-t-2xl shadow-xl p-5 overflow-y-auto transition-transform duration-300 animate-slide-up">
        {/* Header */}
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-semibold text-gray-800">
            Decision - {candidate.CandidateName}
          </h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-red-500 text-sm font-medium"
          >
            <X />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={onSubmit} className="space-y-4 text-sm">
          {/* Decision Select */}
          <div>
            <label htmlFor="decision" className="block text-gray-600 mb-1">
              Decision
            </label>
            <select
              id="decision"
              name="decision"
              value={decisionData.decision}
              onChange={onChange}
              required
              className="w-full border rounded-lg px-3 py-2 text-gray-700 text-sm focus:ring-2 focus:ring-blue-400"
            >
              <option value="">Select Decision</option>
              <option value="Selected">Selected</option>
              <option value="Rejected">Rejected</option>
            </select>
          </div>

          {/* Feedback Textarea */}
          <div>
            <label htmlFor="feedback" className="block text-gray-600 mb-1">
              Feedback
            </label>
            <textarea
              id="feedback"
              name="feedback"
              value={decisionData.feedback}
              onChange={onChange}
              placeholder="Enter feedback..."
              required
              className="w-full border rounded-lg px-3 py-2 text-gray-700 text-sm focus:ring-2 focus:ring-blue-400"
            />
          </div>

          {/* Action Buttons */}
          <div className="flex justify-end gap-3 pt-2 mt-5">
            <button
              type="button"
              onClick={onClose}
              className="px-3 py-1.5 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300 text-sm"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-3 py-1.5 bg-blue-600 text-white rounded-md hover:bg-blue-700 text-sm disabled:bg-blue-300 disabled:cursor-not-allowed flex items-center gap-2"
            >
              {loading ? (
                "Submitting..."
              ) : (
                "Submit"
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default DecisionModal;
